import { registerModal } from '@/context/modalProvider'

import { RecipeDetail } from './components//RecipeDetail'
import {
  EditDeliveryFrequencyBenefit,
  type EditDeliveryFrequencyBenefitProps
} from './components/EditDeliveryFrequencyBenefit'
import { EditRecipesNotSaved } from './components/EditRecipesNotSaved/EditRecipesNotSaved'
import { HowToFeed, type HowToFeedProps } from './components/HowToFeed'
import { RecipesMakeRoomForMore } from './components/RecipesMakeRoomForMore'
import { MakeRoomForMorePropsData } from './components/RecipesMakeRoomForMore/RecipesMakeRoomForMore'
import { RedeemDiscountModal } from './components/RedeemDiscountModal/RedeemDiscountModal'
import { WhereToStart, type WhereToStartProps } from './components/WhereToStart'
import { OrderSummaryModal } from '@/components/modals/OrderSummaryModal'

registerModal('order-summary-modal', OrderSummaryModal)
registerModal<HowToFeedProps>('how-to-feed-modal', HowToFeed)
registerModal<WhereToStartProps>('where-to-start-modal', WhereToStart)
registerModal<EditDeliveryFrequencyBenefitProps>(
  'edit-delivery-frequency-benefit-modal',
  EditDeliveryFrequencyBenefit
)
registerModal('recipe-detail-modal', RecipeDetail)
registerModal('edit-recipes-not-saved-modal', EditRecipesNotSaved)
registerModal('redeem-discount-modal', RedeemDiscountModal)
registerModal<MakeRoomForMorePropsData>(
  'recipes-make-room-for-more',
  RecipesMakeRoomForMore
)
